import { render, staticRenderFns } from "./StudyPlan.vue?vue&type=template&id=632ffd3e&scoped=true&"
import script from "./StudyPlan.vue?vue&type=script&lang=js&"
export * from "./StudyPlan.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlan.vue?vue&type=style&index=0&id=632ffd3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ffd3e",
  null
  
)

export default component.exports